import { render } from "./CommonHorizontalRecipeListItem.vue?vue&type=template&id=b1b6dfd0&scoped=true&ts=true"
import script from "./CommonHorizontalRecipeListItem.vue?vue&type=script&lang=ts"
export * from "./CommonHorizontalRecipeListItem.vue?vue&type=script&lang=ts"

import "./CommonHorizontalRecipeListItem.vue?vue&type=style&index=0&id=b1b6dfd0&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b6dfd0"]])

export default __exports__